// Plan prices in CHF, excl. VAT. Yearly = 11 × monthly (one month free).
// Single source for billing, /preise and the start page.
export const PLANS = {
  starter: {
    monthly: 69,
    yearly: 759,
    fullYearly: 69 * 12,
    saveChf: 69,
    savePercent: 8,
  },
  professional: {
    monthly: 129,
    yearly: 1419,
    fullYearly: 129 * 12,
    saveChf: 129,
    savePercent: 8,
  },
}
